import json from './sprite.js';

export default {
    handle: 'SP_SPT6-Chores',
    label: 'es_SPT6-Chores_234684193',
    json,
};
